import { validateAndGet } from '../../helpers/validation.js';
import {showFeetInches, wsParseLength} from '../../units/units.js'
import {SpanClass} from '../../models/beam.js'

class SpanDialogComponent extends HTMLElement {

  spans = []

  constructor() {
    super();
    document.addEventListener('shear-moment-project-loaded', async (event) => this.onUpdate(event.detail), true)
    document.addEventListener('update-span-table', async (event) => this.onUpdate(event.detail), true)
  }

  onUpdate(beam) {

    document.getElementById('span-dialog-error').classList.add('d-none')

    this.spans = []
    for(let i = 0; i < beam.spans.length; i++) {
      this.spans.push(new SpanClass(beam.spans[i].x1, beam.spans[i].x2))
    }

    this._refreshTable()
  }

  _refreshTable() {
    document.getElementById('span-dialog-error').classList.add('d-none')
    let str = "<table class='table'>";
    for( let i = 0; i < this.spans.length; i++ ) {
      var span_num = i + 1;
      str += "<tr>"
      str += "<td style='width:100px;'>Span "+ span_num + "</td>"
      str += `<td><input style='width:100px;' id='span-input-${i}' type='text' name='span-input-${i}' `
      str += `class='text-center' value='${showFeetInches(this.spans[i].length(), true)}'/>`
      str += `<div id='span-input-validation-${i}' class="alert alert-danger d-none">`
      str += 'Please enter a valid span length. e.g. 144 inches or 144</div></td>'
      if(this.spans.length > 1) {
        str += `<td><button type='button' id='span-remove-button-${i}' class='btn btn-sm btn-danger' >Remove</button></td>`
      }
      str += '</tr>'
    }
    str += "</table>";
  
    document.getElementById('span-table').innerHTML = str

    for( let i = 0; i < this.spans.length; i++ ) {
      document.getElementById(`span-input-${i}`).onblur = () => this.updateSpan(i)
      if(this.spans.length > 1) {
        document.getElementById(`span-remove-button-${i}`).onclick = () => this.onRemoveSpanClick(i)
      }
    }

    if(this.spans.length >= 10) {
      document.getElementById('add-left-span-button').classList.add('d-none')
      document.getElementById('add-right-span-button').classList.add('d-none')
    } else {
      document.getElementById('add-left-span-button').classList.remove('d-none')
      document.getElementById('add-right-span-button').classList.remove('d-none')
    }
  }
  onRemoveSpanClick( index ) {
    document.dispatchEvent(new CustomEvent('remove-span', {detail: index}))
  }
  
  onAddLeftSpanClick() {
    var len = this.spans[0].length()
    document.dispatchEvent(new CustomEvent('add-left-span', {detail: len}))
  }

  onAddRightSpanClick() {
    var len = this.spans[0].length()
    document.dispatchEvent(new CustomEvent('add-right-span', {detail: len}))
  }
  
  updateSpan( index ) {
    const lengthValidation = (value) => value > 0 && value < 1e3
    try {
      const spanLength = validateAndGet(`span-input-${index}`, wsParseLength, lengthValidation, 'Length must be greater than 0 ft and less than 1000 ft.')
      console.log(spanLength)
      if(spanLength) {
        document.dispatchEvent(new CustomEvent('update-span', {detail: {index: index, spanLength: spanLength}}))
      }
    } catch (e) {
      document.getElementById('span-dialog-error').classList.remove('d-none')
      document.getElementById('span-dialog-error').innerHTML = e
    }
  }
  
  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="span-dialog" tabindex="-1" role="dialog"
      aria-labelledby="span-dialog-label" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Spans</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div id="span-table"></div>
            <button id="add-left-span-button" type="button" class="btn btn-success btn-md">
              Add Left Span
            </button>
            <button id="add-right-span-button" type="button" class="btn btn-success btn-md">
              Add Right Span
            </button>
          </div>
          <br>
          <div id='span-dialog-error' class="alert alert-danger d-none" role="alert">
              Validation box
          </div>
          <br>
          <div class="alert alert-info" role="alert">
            Support Conditions can be changed by clicking on them in the drawing.
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
      `
    
    document.getElementById('add-left-span-button').onclick = () => this.onAddLeftSpanClick()
    document.getElementById('add-right-span-button').onclick = () => this.onAddRightSpanClick()
    
    document.getElementById('span-dialog').addEventListener('hidden.bs.modal', () => {
      this._refreshTable()
    })
  }
  
}

customElements.define('span-dialog-component', SpanDialogComponent);
















